import { Directive } from '@angular/core';

@Directive({
  selector: '[appOrderByItems]'
})
export class OrderByItemsDirective {}
